import React from "react";
import { Plus, Wand2, Loader2, Route } from "lucide-react";
import { Button } from "../../ui/button";

export function RouteTabsList({ tempRoutes, activeTempId, onSelect, onHover, onNewRoute, onPlanAutomatically, mode, onAutoAssign, autoAssigning, onOptimizeAll, optimizingAll }) {
  return (
    <div className="mb-3 flex flex-wrap items-center gap-2" data-testid="route-tabs-list">
      {tempRoutes.map((r) => (
        <button
          key={r.tempId}
          onClick={() => onSelect(r.tempId)}
          onMouseEnter={() => onHover(r.tempId)}
          onMouseLeave={() => onHover(null)}
          className={`flex items-center gap-1.5 rounded-full border px-3 py-1.5 text-xs font-semibold transition-all ${
            activeTempId === r.tempId ? "border-primary bg-primary text-white" : "border-border bg-surface text-text-main hover:bg-background"
          }`}
          data-testid={`route-tab-${r.tempId}`}
        >
          <span className="h-2.5 w-2.5 rounded-full" style={{ background: activeTempId === r.tempId ? "#fff" : r.color }} />
          {r.existingRouteId ? `Editing #${r.existingRouteId}` : `Route ${r.tempId}`} · {r.driverName || "No driver"} (#{r.driverId}) · {r.deliveryIds.size}
        </button>
      ))}
      {mode === "automatic" ? (
        <Button variant="outline" size="sm" onClick={onPlanAutomatically} data-testid="plan-automatically-button">
          <Wand2 size={14} strokeWidth={2} /> Plan Automatically
        </Button>
      ) : (
        <Button variant="outline" size="sm" onClick={onNewRoute} data-testid="new-route-button">
          <Plus size={14} strokeWidth={2} /> New Route
        </Button>
      )}
      {onAutoAssign && tempRoutes.length > 0 && (
        <Button variant="outline" size="sm" onClick={onAutoAssign} disabled={autoAssigning} data-testid="auto-assign-button">
          {autoAssigning ? <Loader2 size={14} className="animate-spin" /> : <Wand2 size={14} strokeWidth={2} />}
          Auto-Assign
        </Button>
      )}
      {onOptimizeAll && tempRoutes.some((r) => r.deliveryIds.size > 0) && (
        <Button variant="outline" size="sm" onClick={onOptimizeAll} disabled={optimizingAll} data-testid="optimize-all-button">
          {optimizingAll ? <Loader2 size={14} className="animate-spin" /> : <Route size={14} strokeWidth={2} />}
          Optimize All
        </Button>
      )}
    </div>
  );
}


